import * as z from "zod/v4";

const statisticalSignificanceOutputSchema_ = z.object({
  /** P-value from the statistical test (0 to 1) */
  pValue: z.number().min(0).max(1),
  /** Percentage improvement of variant over control; null if control is zero */
  percentageImprovement: z.number().nullable(),
  /** Traffic percentage allocated to variant (0-100); control is 100 minus this */
  variantTrafficPercentage: z.number().min(0).max(100),
  /** How marketing agent compares to legacy automations */
  improvementDirection: z.enum(["better", "worse", "comparable"]),
});
export const statisticalSignificanceOutputSchema: z.ZodType<StatisticalSignificanceOutput> =
  statisticalSignificanceOutputSchema_;
export interface StatisticalSignificanceOutput
  extends z.infer<typeof statisticalSignificanceOutputSchema_> {}

const marketingAgentAnalyticsInputSchema_ = z.object({
  /** Max number of days to look back */
  days: z.number(),
  splitId: z.string().optional(),
});
export const marketingAgentAnalyticsInputSchema: z.ZodType<MarketingAgentAnalyticsInput> =
  marketingAgentAnalyticsInputSchema_;
export interface MarketingAgentAnalyticsInput
  extends z.infer<typeof marketingAgentAnalyticsInputSchema_> {}

export const getMarketingAgentStatisticalSignificance = {
  name: "getMarketingAgentStatisticalSignificance" as const,
  input: marketingAgentAnalyticsInputSchema,
  output: statisticalSignificanceOutputSchema.nullable(),
};
